import { yupResolver } from '@hookform/resolvers/yup';
import { interpolate } from '@discover-frontend/utils';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

import translations from 'src/lang';
import { useEffect } from 'react';
import { useAudienceActivationContext } from '../../../providers/AudienceActivationProvider';

const lang = 'en-US';
const translation = translations[lang].COMMON.ERROR_MESSAGES;

const MAX_LENGTH_CAMPAIGN_NAME = 80;
const MAX_LENGTH_ADDITIONAL_NOTES = 320;

export const useAudienceForm = () => {
  const { repositoryItem } = useAudienceActivationContext();

  const schema = yup.object().shape({
    campaignName: yup
      .string()
      .required(translation.MANDATORY_FIELD)
      .max(
        MAX_LENGTH_CAMPAIGN_NAME,
        interpolate(translation.MAX_LENGTH, { max: MAX_LENGTH_CAMPAIGN_NAME })
      ),
    dateRange: yup
      .object({
        startDate: yup.string().required(translation.MANDATORY_FIELD),
        endDate: yup.string().required(translation.MANDATORY_FIELD),
      })
      .required(),
    additionalNotes: yup.string().max(
      MAX_LENGTH_ADDITIONAL_NOTES,
      interpolate(translation.MAX_LENGTH, {
        max: MAX_LENGTH_ADDITIONAL_NOTES,
      })
    ),
  });

  const {
    control,
    trigger,
    getValues,
    reset,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onBlur',
    resolver: yupResolver(schema),
    defaultValues: {
      campaignName: '',
      dateRange: {
        startDate: '',
        endDate: '',
      },
      additionalNotes: '',
    },
  });

  useEffect(() => {
    if (!repositoryItem) return;

    reset({
      campaignName: repositoryItem?.campaign?.campaignName || '',
      dateRange: {
        startDate: repositoryItem?.campaign?.startDate || '',
        endDate: repositoryItem?.campaign?.endDate || '',
      },
      additionalNotes: repositoryItem?.campaign?.additionalNotes || '',
    });
  }, [repositoryItem, reset]);

  return {
    control,
    trigger,
    getValues,
    errors,
    isValid,
  };
};
